import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { add as addToCart } from '../Actions/Cart.action';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.state = {
            loading: false
        }
    }

    handleAddToCart(articleNumber, quantityFieldId) {
        try {
            this.setState({ 
                loading: true 
            });
            
            this.props.addToCart(this.buttonRef.current, articleNumber)
                .then(() => setTimeout(() => this.setState({ loading: false }), 1000));
        } 
        catch (err) {
            console.error("Could not add item to cart:", err);
            this.setState({ loading: false })
        }
    }

    render() {
        return (
            <buy-button-container ref={this.buttonRef}>
                <BuyButton {...this.props} 
                    onClick={(articleNumber, quantityFieldId) => this.handleAddToCart(articleNumber, quantityFieldId)}
                    loading={this.state.loading}
                />
            </buy-button-container>
        );
    }
}

const mapStateToProps = state => {
    return { }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
        addToCart: async (buttonDomNode, articleNumber) => {
            await dispatch(addToCart({ 
                articleNumber, 
                quantity: 1,
                hash: Date.now(),
            }))
            .then((result) => result)
            .catch((err) => console.log("err", err));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyButtonContainer);